module.exports = __webpack_public_path__ + "media/src/images/top_covers/giftee_haloween03-0870de3c7aa996be0508a24b103c6e68.png";